// (function () {
//   function swiperInit() {
//     subSliderInit(true);
//     sliderInit(true);
//   }

//   document.addEventListener("shopify:section:load", function (e) {
//     swiperInit();
//   });

//   window.addEventListener("resize", function () {
//     $(".product-section .js-media-list").each(function () {
//       this.swiper.destroy();
//     });
//     $(".product-section .js-media-sublist").each(function () {
//       this.swiper.destroy();
//     });

//     swiperInit();
//   });

//   swiperInit();
// })();


(function () {
  function swiperInit() {
    subSliderInit(true);
    sliderInit(true);
  }

  document.addEventListener("shopify:section:load", function () {
    swiperInit();
  });

  let lastWindowWidth = window.innerWidth;

  window.addEventListener("resize", function () {
    const currentWindowWidth = window.innerWidth;

    
    if (currentWindowWidth === lastWindowWidth) {
      return;
    }

    lastWindowWidth = currentWindowWidth;

    $(".product-section .js-media-list").each(function () {
      if (this.swiper) {
        this.swiper.destroy();
      }
    });

    $(".product-section .js-media-sublist").each(function () {
      if (this.swiper) {
        this.swiper.destroy();
      }
    });

    swiperInit();
  });

  swiperInit();
})();